export default "__VITE_ASSET__73d03df3__"